export default "__VITE_ASSET__OD7hJIYA__"